import env from './test';

env.aws.cookie_domain = 'localhost';

export default env;
